/**
 * @description Gestion des tailles de textes coupés
 */

(() => {
  // FONCTIONS
  // Lancement de la librairie clamp sur chaque éléments dotdot @see https://github.com/josephschmitt/Clamp.js
  const dotdot = () => {
    document.querySelectorAll('[data-dot]').forEach(element => {
      const lines = element.getAttribute('data-dot');
      $clamp(element, { clamp: lines });
    });
  };

  const dotP = ($content, $lines) => {
    document.querySelectorAll($content).forEach(element => {
      element.setAttribute('data-dot', $lines);
    });
    document.querySelectorAll(`${$content}> p`).forEach(element => {
      element.setAttribute('data-dot', $lines);
    });
    document.querySelectorAll(`${$content}> span`).forEach(element => {
      element.setAttribute('data-dot', $lines);
    });
  };

  // EVENTS
  const events = () => {
    const obs = new MutationObserver(() => {
      dotdot();
    });

    obs.observe(config.root, {
      childList: true,
    });
  };

  // GO 🚀
  const init = () => {
    dotP('div.lead', '3');
    dotP('div.card-text', '4');
    dotP('div.gallery', '3');
    dotP('div.rt__grid__result__item h3', '3');
    dotdot();
    events();
  };

  init();
})();
